var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tip-controller',{attrs:{"subject":_vm.tipSubject},on:{"success":_vm.setSuccess},scopedSlots:_vm._u([{key:"tip-view",fn:function(ref){
var user = ref.user;
var processing = ref.processing;
var value = ref.value;
var onInput = ref.onInput;
var currencySymbol = ref.currencySymbol;
var feedId = ref.feedId;
var onSubmit = ref.onSubmit;
return [_c('post-tipping-modal',{attrs:{"currency-symbol":currencySymbol,"processing":processing,"user":user,"value":value,"feed-id":feedId,"success":_vm.success,"subject-type":_vm.subjectType},on:{"submit":onSubmit,"input":onInput,"close":function($event){return _vm.$emit('close')}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }